export default __webpack_public_path__ + "c9463e295b6e6d2f0a011e26c02fe4f8.png";